import api from '../../../services/Api';
import { IAuditoriaZeramento13Resultado } from '../interfaces/IAuditoriaZeramento13';

export const AuditoriaZeramento13Service = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaZeramento13Resultado> {
    const response = await api.get<IAuditoriaZeramento13Resultado>('auditoria-zeramento-13/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoSaldoFinal: '',
        fundamentacaoSaldoInicial: '',
        fundamentacaoProvisaoMensal: '',
        saldoFinalNaoZerado: [],
        saldoInicialNaoZerado: [],
        provisaoMensalAusente: [],
        contasConciliadas: [],
      }
    );
  },
};
